/**
 * Client-side API calls for the server-side Listings API.
 */

const postJson = (path, body) =>
  fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  }).then(res => res.json());

/**
 * Increment listing view count (anonymous).
 * @param {string} listingId
 */
export const incrementViewCount = listingId =>
  postJson('/api/listings/update-view-count', { listingId });

/**
 * Update listing metadata (authenticated, author only).
 * @param {string} listingId
 * @param {Object} metadata - e.g. { trending: true, featured: false }
 */
export const updateListingMetadata = (listingId, metadata) =>
  postJson('/api/listings/update-metadata', { listingId, metadata });
